import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/velkoobchod" as const,
	[Locale.en]: "/wholesale" as const,
} satisfies LocalizedString;

export function getWholesalePath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
